import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';

export const Container = styled(Row)`
  background-color: ${({ theme }) => theme.colors.bodyBg};
`;

export const TextContainer = styled.span`
  text-align: left;
`;
